import { Component, Input } from "@angular/core";
import { Utilities } from "../../providers/utilities";

@Component({
  selector: "app-state-list",
  templateUrl: "state-list.html",
})
export class StateListComponent {

  @Input() public state: any;
  @Input() public isInactive: boolean = false;

  constructor(
    private utilities: Utilities,
  ) { }

  public calculateTooltip(state) {
    if (this.isInactive) {
      if (state) {
        return "Inactive";
      }
      return "Active";
    } else {
      switch (state) {
        case true:
          return "Active";

        case false:
          return "Inactive";

        default:
          return state;
      }
    }
  }

  public calculateIcon(state) {
    if (this.isInactive) {
      if (state) {
        state = false;
      }
      state = true;
    }
    return this.utilities.getIconState(state);
  }

  public calculateColor(state) {
    if (this.isInactive) {
      if (state) {
        state = false;
      }
      state = true;
    }
    return this.utilities.getColorState(state);
  }
}



// WEBPACK FOOTER //
// ./src/components/state-list/state-list.ts